module.exports = __webpack_public_path__ + "static/img/404_icon.b19c529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404_icon.png
// module id = dAhl
// module chunks = 1